export function formatIdentifierType(raw) {
    const normalized = raw == null ? '' : String(raw).trim();
    return normalized ? normalized.toUpperCase() : '';
}

export function getUploadedIdentifierForRow(row = {}) {
    const inboundValue = row?.inbound_id_value == null ? '' : String(row.inbound_id_value).trim();
    const inboundType = row?.inbound_id_type == null ? '' : String(row.inbound_id_type).trim();
    return {
        type: inboundValue ? formatIdentifierType(inboundType) : '',
        value: inboundValue,
    };
}
